// s61-list_contacts.js
import selfHtml from './s61-list_contacts.html' with { type: 'text' };;

import { KeyDetailsModule, db_ExtPub, mod_loader, ListContactsModule, MsgComposeModule, ShareModule } from "../AppState.js";
import { get_pub_key, is_my_pubkey } from "../crypt_helper.js";
import { navbar_active_menu } from '../utils.js';

var listgroup_contacts
var listgroup_item_master
var listDetails
var listPanel
var my_pub_key
var btn_delete_contact
var btn_reply_2contact_message
var btn_share_contact
var selected_contact
var root

const SCREEN_SIZE__MD = 768

export async function init(module_root, args) {

    module_root.innerHTML = selfHtml;

    root = module_root
    listgroup_contacts = root.querySelector(".list-group");
    listgroup_item_master = root.querySelector(".list-group-item").cloneNode(true);
    listDetails = root.querySelector(".listDetails");
    listPanel = root.querySelector(".listPanel");

    btn_delete_contact = root.querySelector(".btn_delete_contact");
    btn_reply_2contact_message = root.querySelector(".btn_reply_2contact_message");
    btn_share_contact = root.querySelector(".btn_share_contact");

    btn_reply_2contact_message.addEventListener('click', async () =>
        mod_loader(MsgComposeModule, await get_pub_key(selected_contact.publicKey))
    );

    btn_delete_contact.addEventListener('click', () => {
        db_ExtPub.del(selected_contact.fingerprint);
        mod_loader(ListContactsModule);
    })

    btn_share_contact.addEventListener('click', async () => {

        const url = new URL(window.location)
        const WWW_BASEURL = url.origin + url.pathname;
        const contact = await get_pub_key(selected_contact.publicKey);
        const url_share_link = `${WWW_BASEURL}?pubk=${encodeURIComponent(contact.myKeyPairKeyID)}`;
        const shareData = {
            title: "Forward contact",
            text: "description_why_to_shate",
            url: url_share_link
        };

        mod_loader(ShareModule, { target: ".div_forward_contact_link_section", active_link: url_share_link, shareData });
        root.querySelector(".div_forward_contact_link_section").classList.remove("d-none");

    });

    navbar_active_menu(".navbar_list_contacts")

    await display_contacts();
}
// -------------------------------------------------------------------------------------------
async function display_contacts() {

    my_pub_key = await get_pub_key();

    const contacts = await db_ExtPub.keys();

    if (contacts.length)
        listgroup_contacts.innerHTML = ''
    else
        listgroup_contacts.innerHTML = "No items"

    // To sort the main array by username it is needed to build array key/names 
    var names = [];

    for (const key of contacts) {
        const user = await db_ExtPub.get(key);
        names[key] = user.userID[0];
    }

    contacts.sort((a, b) =>
        names[a].localeCompare(names[b])
    );

    for (const key of contacts) {
        const contact = await db_ExtPub.get(key);
        await add_item(contact);
        contact.was_displayed = true;
        db_ExtPub.set(key, contact);
    }

}
// -------------------------------------------------------------------------------------------
async function add_item(contact) {

    const item = listgroup_item_master.cloneNode(true);

    item.querySelector(".contact_userid").innerText = contact.userID[0];
    item.querySelector(".contact_date").innerText = new Date(contact.date).toLocaleString();

    // The user Name is Bold
    if (my_pub_key?.myKeyPairFingerprint == contact.fingerprint)
        item.querySelector(".contact_userid").classList.add("fw-bold")

    if (contact.was_displayed == true)
        item.querySelector(".item_new_circle").style.display = 'none';


    item.addEventListener('click', async (event) => {

        if (event) event.preventDefault(); // Not sure if this is needed at all.

        // global variable used by the Delete and Reply buttons
        selected_contact = contact

        // Clear all highlight list-item 
        const listArray = Array.from(event.target.closest(".list-group").children)
        listArray.forEach(child_item => child_item.classList.remove("active"));

        // highlight one list-item 
        event.target.closest(".list-group-item").classList.add("active");

        btn_delete_contact.classList.remove("d-none");
        btn_reply_2contact_message.classList.remove("d-none");
        btn_share_contact.classList.remove("d-none");
        root.querySelector(".div_forward_contact_link_section").classList.add("d-none");


        // Allow to delete a pubkey as long as it doesn't belong to the user's
        btn_delete_contact.disabled = my_pub_key.myKeyPairFingerprint == contact.fingerprint;
        btn_reply_2contact_message.disabled = btn_delete_contact.disabled

        // handle the view on phones screens
        if (window.innerWidth < SCREEN_SIZE__MD) {
            listPanel.classList.add('d-none');
            listDetails.classList.remove('d-none');
        }

        listDetails.querySelector(".btn_back_to_list").addEventListener('click', () => {
            if (window.innerWidth < SCREEN_SIZE__MD) {
                listPanel.classList.remove('d-none');
                listDetails.classList.add('d-none');
            }
        })

        // Show the details on the right panel
        mod_loader(KeyDetailsModule, {
            target: ".detailContent", 'key': {
                myKeyPairUserID: contact.userID[0],
                myKeyPairFingerprint: contact.fingerprint,
                myKeyPairKeyID: contact.keyID,
                myKeyPairPublicKey: contact.publicKey,
                isSelfKey: btn_delete_contact.disabled,
            }
        })

    });

    item.querySelectorAll("div").forEach(div => { div.classList.add("text-body-secondary") })

    listgroup_contacts.appendChild(item)

}
// -------
